/* 🤖 this file was generated by svg-to-ts */
export const matIconMan4: {
  name: 'man-4';
  data: string;
} = {
  name: 'man-4',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13.75 7h-3.5C9.04 7 8.11 8.07 8.27 9.26L10 22h4l1.73-12.74C15.89 8.07 14.96 7 13.75 7z"/><circle cx="12" cy="4" r="2"/></svg>`
};
